import { createAsyncThunk } from "@reduxjs/toolkit";

import apiRequest from "../../../services/api";

// Org overview data
export const getDashboardData = createAsyncThunk(
  "org_data_aggregator/getDashboardData",
  async (body) => {
    const verifyDetails = await apiRequest.get(
      `v1/organizations/org_data_aggregator/`,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return verifyDetails.data;
  }
);

// Team statistics data
export const getTeamStatisticsData = createAsyncThunk(
  "reports/team_statistics/?team_name=${body.team_name}/getTeamStatisticsData",
  async (body) => {
    const verifyDetails = await apiRequest.get(
      `v1/reports/team_statistics/?team_name=${body.team_name}`,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return verifyDetails.data;
  }
);

// User engagement data
export const getUserEngagementData = createAsyncThunk(
  "org_data_aggregator/getUserEngagementData",
  async (body) => {
    const userEngagementResponse = await apiRequest.get(
      `v1/reports/user_engagement/`,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return userEngagementResponse.data;
  }
);

// User tracker report data
export const getUserStatisticsData = createAsyncThunk(
  "org_data_aggregator/getUserStatisticsData",
  async (body) => {
    const userEngagementResponse = await apiRequest.get(
      `v1/reports/user_statistics/`,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return userEngagementResponse.data;
  }
);

// Tournament clinic engagement report
export const clinicTournamentEngagement = createAsyncThunk(
  "organizations/dashboard/clinicEngagement",
  async (body) => {
    let query = "";
    if (body.tournamentName) {
      query = query + `tournament_name=${body.tournamentName}&`;
    }
    try {
      const api = await apiRequest.get(
        `v1/dashboard/clinic/engagement/?${query}`,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return api.data;
    } catch (error) {
      throw error;
    }
  }
);
